import React, { PureComponent } from 'react';
import InputColor from 'react-input-color';
import { getHexColor } from 'src/util/misc';

interface EngravingProps {
    id: string;
    color: string;
    updateEffectProperty: (data: { id: string; property: string; value: any }) => void;
}

export default class Engraving extends PureComponent<EngravingProps> {
    render() {
        const { id, color, updateEffectProperty } = this.props;

        const handleChange = (evt: { hex: string }) => {
            updateEffectProperty({ id, property: 'color', value: getHexColor(evt.hex) });
        };

        return (
            <div className='blending'>
                <h3>Engraving Settings</h3>
                <div className='blending__engraving-color-wrapper'>
                    <span>Engraving Color</span>
                    <InputColor initialValue={color} onChange={handleChange} placement='top' />
                </div>
            </div>
        );
    }
}
